import type { InquiryHeroArtProps } from '../constants/inquiries'

export function InquiryHeroArt({ variant }: InquiryHeroArtProps) {
  if (variant === 'b2b') {
    return (
      <svg className="inquiry-art" viewBox="0 0 360 260" fill="none" aria-hidden>
        <rect x="210" y="86" width="118" height="92" rx="10" fill="#1b4332" />
        <rect x="218" y="94" width="102" height="18" rx="4" fill="#d8eee2" />
        <text x="269" y="107" textAnchor="middle" fill="#1b4332" fontSize="8" fontFamily="Manrope, sans-serif">
          maaliondoor
        </text>
        <rect x="232" y="122" width="74" height="42" rx="6" fill="#f6f1e4" />
        <circle cx="250" cy="143" r="8" fill="#c0392b" />
        <circle cx="268" cy="143" r="8" fill="#d4a017" />
        <circle cx="286" cy="143" r="8" fill="#c0392b" />
        <path d="M80 210c40-84 70-120 118-148" stroke="#2d6a4f" strokeWidth="8" strokeLinecap="round" />
        <ellipse cx="198" cy="62" rx="22" ry="28" fill="#f4f1ea" transform="rotate(-18 198 62)" />
        <ellipse cx="172" cy="58" rx="20" ry="26" fill="#fff" transform="rotate(12 172 58)" />
        <ellipse cx="186" cy="44" rx="18" ry="24" fill="#f7f4ee" />
        <circle cx="186" cy="70" r="10" fill="#d8eee2" />
        <circle cx="148" cy="92" r="16" fill="#f4d7e3" />
        <circle cx="132" cy="108" r="14" fill="#e8f3ec" />
        <circle cx="164" cy="104" r="13" fill="#fff" />
      </svg>
    )
  }

  return (
    <svg className="inquiry-art" viewBox="0 0 360 260" fill="none" aria-hidden>
      <ellipse cx="250" cy="210" rx="86" ry="18" fill="rgba(20,46,34,0.18)" />
      <path d="M168 214c28-92 64-138 122-168" stroke="#2f6f4e" strokeWidth="10" strokeLinecap="round" />
      <path d="M196 206c18-40 8-72-18-96" stroke="#40916c" strokeWidth="7" strokeLinecap="round" />
      <circle cx="248" cy="78" r="26" fill="#f4d7e3" />
      <circle cx="278" cy="96" r="22" fill="#fff" />
      <circle cx="222" cy="98" r="20" fill="#f7c1d4" />
      <circle cx="256" cy="118" r="18" fill="#fff7fb" />
      <circle cx="204" cy="128" r="16" fill="#d8eee2" />
      <circle cx="292" cy="128" r="15" fill="#95d5b2" />
      <circle cx="236" cy="58" r="14" fill="#fff" />
      <rect x="286" y="148" width="52" height="64" rx="8" fill="#f4f1ea" />
      <circle cx="312" cy="168" r="10" fill="#2d6a4f" />
      <path d="M40 40c18 28 8 46-10 62" stroke="rgba(45,106,79,0.18)" strokeWidth="10" strokeLinecap="round" />
      <path d="M318 28c-16 22-6 40 12 56" stroke="rgba(45,106,79,0.14)" strokeWidth="10" strokeLinecap="round" />
    </svg>
  )
}
